import { ContentBox } from 'common/components/AppLayout/ContentBox';
import { TableSkeleton } from 'common/components/Table/TableSkeleton';
import { SuspenseLoadingView } from 'common/components/SuspenseLoadingView';
import { TableWithFiltersLayout } from 'common/components/AppLayout/TableWithFiltersLayout';

import { SimProductsFilters } from './Filters/SimProductsFilters';
import { useCustomFieldsFiltersInitialization } from './Filters/hooks/useCustomFieldsFiltersInit';

import { SimProductTagProvider } from './Tags/SimProductTagProvider';
import { SimProductsTable } from './Inventory/Components/SimProductsTable';
import { simProductsQueries } from './Inventory/queries/simProductsQueries';

import { useTabNavigationSetter } from 'src/common/components/AppLayout/AppNavigation/hooks/useTabNavigationSetter';
import { productNavigationAtom } from 'src/atoms/pages/pages';
import { useSimProductUrlFromFilters } from './hooks/useSimProductUrlFromFilters';
import { SimFiltersURLParser } from './Filters/SearchParams/SimFiltersURLParser';
import { TabPanelWithErrorHandling } from 'src/common/components/AppLayout/Components/TabPanelWithErrorHandling';
import { ProductsTabs } from '../layout/ProductsTabs';
import { PageWithGraphs } from 'src/common/components/Layouts/PageLayout/PageWithGraphs';
import { useHasFeatureFlag } from 'src/featureFlags/useHasFeatureFlag';
import { SimProductsGraphs } from './graphs/SimProductsGraphs';

import { openProductGraphsContainer } from 'src/atoms/ui/graphs';
import { ExternalRowSelectionProvider } from 'src/common/components/ConfigurableTable/Components/Rows/ExternalRowSelection/ExternalRowSelectionProvider';
import { SimProductsSelectionReset } from './Inventory/Components/SimProductsSelectionReset';

const SimProductsNavigationSetter = () => {
  const url = useSimProductUrlFromFilters();
  useTabNavigationSetter({ tabsAtom: productNavigationAtom, routeToSet: url });
  return null;
};

export const SimProductsTab = () => {
  const isCustomFieldsProcessed = useCustomFieldsFiltersInitialization();
  const analyticsModuleEnabled = useHasFeatureFlag('AnalyticsModule');

  const dashboardEnabled = analyticsModuleEnabled;

  return (
    <PageWithGraphs
      graphs={dashboardEnabled && <SimProductsGraphs />}
      slots={{
        graphsContainer: {
          openAtom: openProductGraphsContainer,
        },
      }}
    >
      <ProductsTabs>
        <TabPanelWithErrorHandling name={'SIM'}>
          <ExternalRowSelectionProvider>
            <SimProductsSelectionReset />
            <SimProductTagProvider>
              <TableWithFiltersLayout filters={<SimProductsFilters />}>
                <SuspenseLoadingView
                  loadFallback={
                    <ContentBox>
                      <TableSkeleton showStartSkeleton showEndSkeleton numberOfRows={20} />
                    </ContentBox>
                  }
                  queryKey={simProductsQueries.all}
                  forceLoadFallback={!isCustomFieldsProcessed}
                >
                  <SimProductsTable />
                </SuspenseLoadingView>
              </TableWithFiltersLayout>
            </SimProductTagProvider>
          </ExternalRowSelectionProvider>
        </TabPanelWithErrorHandling>
      </ProductsTabs>
    </PageWithGraphs>
  );
};

export const SimProducts = () => {
  return (
    <SimFiltersURLParser>
      <SimProductsNavigationSetter />
      <SimProductsTab />
    </SimFiltersURLParser>
  );
};
